module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "dale-lomax.3565516a.png";